import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconButton, Typography, Button } from "@mui/material"
import { sxTypographyTitle, sxButtonOptionRecovery } from "../sxProps"
import alertIcon from '../../../assets/images/triangle-exclamation.png';
import { AlertRecoveryQuestionsProps } from "../../../interfaces/props/passwordRecovery/AlertRecoveryQuestionsProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";


const AlertRecoveryQuestions: React.FC<AlertRecoveryQuestionsProps> = ({ formBack, openRecoveryQuestions }) => {

  const { textStyleAccessibility, buttonStyleAccessibility, buttonTextStyleAccessibility } = useAccessibility();

  return (
    <div style={textStyleAccessibility} className='container-login-painel-rigth'>
      <div className='password-recovery-container-text'>
        <div className='width-100'>
          <IconButton aria-label="Voltar" onClick={() => formBack()} type="button">
            <FontAwesomeIcon style={textStyleAccessibility} icon={faArrowLeft} />
          </IconButton>
          <div className='width-100 password-recovery-alert-container-icon'>
            <img src={alertIcon} alt="Icone de alerta." />
          </div>
          <Typography style={textStyleAccessibility} sx={sxTypographyTitle} className='margin-bottom-painel-rigth'>Revalidação de dados</Typography>
        </div>
        <div className='container-text-recovery '>
          <span style={{ color: '#4C4C4C', ...textStyleAccessibility}} className='login-text login-text-center'>Para corrigir seus dados e prosseguir com a redefinição de senha, é necessário responder ao questionário para confirmar algumas informações.</span>
        </div>
        <div className='container-text-recovery '>
          <span style={textStyleAccessibility} className='login-text login-text-center'>Importante: caso alguma informação seja respondida de forma equivocada, a redefinição ficará bloqueado por 24 horas. Após esse período, você poderá realizar uma nova tentativa.</span>
        </div>
      </div>
      <div className='width-100'>
        <Button style={buttonStyleAccessibility} sx={sxButtonOptionRecovery} onClick={() => openRecoveryQuestions()} variant='contained'>
          <Typography style={buttonTextStyleAccessibility}>INICIAR QUESTIONÁRIO PARA REVALIDAR SEUS DADOS</Typography>
        </Button>
      </div>
    </div>
  )
}

export default AlertRecoveryQuestions